export default {"src":"/_next/static/media/logo.efde49dd.svg","height":620,"width":2329};